import { Observable, Subject, debounceTime, filter, map, takeUntil, tap } from 'rxjs';
import { AfterViewInit, Component, OnDestroy, ViewChild } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { NgScrollbar } from 'ngx-scrollbar';
import { ListState } from '@app/store/list.state';
import { Format } from '@app/models';
import { searchStagger, formatHide } from '@app/animations';
import { SetScrollPosition } from '@app/store/portal.actions';

@Component({
  selector: 'prp-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss'],
  animations: [searchStagger, formatHide],
})
export class ListComponent implements AfterViewInit, OnDestroy {
  @Select(ListState.searchResults) data$: Observable<Format[]>;
  @Select(ListState.formatSelected) format$: Observable<string>;

  @ViewChild(NgScrollbar) scrollbar: NgScrollbar;

  private destroy$ = new Subject<void>();

  constructor(private store: Store) {}

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngAfterViewInit() {
    this.scrollbar?.scrolled
      .pipe(
        takeUntil(this.destroy$),
        debounceTime(100),
        map((e: any) => e?.target),
        filter((t: any) => !!t),
        tap((t: any) => this.store.dispatch(new SetScrollPosition(t?.scrollTop)))
      )
      .subscribe();
  }
}
